import React from "react";
import { Col, Row } from "antd";
import { MyProgressBar } from "../animation/progressBar";
import { skill } from "../constant/skills";
import { motion } from "framer-motion";
import { useStaggerReveal } from "../animation/scrollReveal";

const Skill = () => {
  const containerRef = useStaggerReveal(".skill-reveal-item", { from: { opacity: 0, y: 70 } });
  return (
    <>
      <div style={{
        textAlign: "center", marginBottom: 30
      }} className="header">
        <i className="fa fa-laptop-code title-icon" />
        SKILLS
      </div>
      <Row gutter={[24, 24]} style={{ margin: 0 }} ref={containerRef}>
        {skill.map((v, k) => (
          <Col xs={24} md={12} lg={12} key={k} className="skill-reveal-item">
            <motion.div
              className="page"
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <SkillCard title={v.title} language={v.language} />
            </motion.div>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default Skill;

const SkillCard = ({ title, language }) => {
  return (
    <div
      style={{
        background: "#ffffff",
        padding: 24,
        border: "1px solid var(--card-border)",
        textAlign: "center",
        boxShadow: "6px 6px 0px var(--bg-dark)",
        transition: "all 0.2s ease-in-out",
        position: "relative",
        overflow: "hidden",
      }}
      className="skill-card"
    >
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "6px",
        background: "var(--accent-color)",
      }} />
      <div className="title" style={{ marginBottom: "20px", fontSize: "22px" }}>{title}</div>
      {language.map((v, k) => (
        <Row align="middle" style={{ margin: 0, paddingBottom: 15 }} key={k}>
          <Col xs={2} sm={2} md={2} style={{ textAlign: "center" }}>
            <motion.div
              whileHover={{ scale: 1.2, rotate: 360 }}
              transition={{ duration: 0.5 }}
              style={{
                maxWidth: 40,
                aspectRatio: 1,
                background: "white",
                borderRadius: "var(--radius)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "2px 2px 0px var(--bg-dark)",
                border: "1px solid var(--card-border)"
              }}
            >
              <img src={v.imgURL} width="80%" alt={v.name} />
            </motion.div>
          </Col>
          <Col
            xs={8}
            sm={8}
            md={6}
            style={{ textAlign: "left", paddingLeft: 10, fontSize: "15px", fontWeight: 500 }}
          >
            {v.name}
          </Col>
          <Col xs={14} sm={14} md={16}>
            <MyProgressBar percent={v.level} />
          </Col>
        </Row>
      ))}
    </div>
  );
};
